import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=18dbf5d6&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18dbf5d6')) {
      api.createRecord('18dbf5d6', component.options)
    } else {
      api.reload('18dbf5d6', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=18dbf5d6&", function () {
      api.rerender('18dbf5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Upkm79RRo1ZC/JS/comp/openstreetmap.vue"
export default component.exports